import { getSdk } from '@descope/vue-sdk';
import { LocationQueryValue } from 'vue-router';
import { clientWithoutInterceptors } from './http';
import DDLogs from '../DDLogs';
import config from '../config';

export async function _descopeAutheticate(token: string): Promise<boolean> {
  if (token) {
    const descopeSdk = getSdk();
    const magicLinkResp = await descopeSdk.magicLink.verify(token);
    if (magicLinkResp.code !== 200) {
      return false;
    }
    // exchange for riseup token
    const response = await clientWithoutInterceptors.get('/api/no-auth/descope/login', {
      headers: {
        Authorization: `Bearer ${magicLinkResp?.data?.sessionJwt}`,
      },
    });
    return response.status === 200;
  }
  return false;
}

const redirectionMap = () => ({
  subscription: `${config.get().billingPublicUrl}/subscription`,
  [`${config.get().billingPublicUrl}/subscription`]: `${config.get().billingPublicUrl}/subscription`,
});

export function resolveRedirection(redirectionUrl: string | null): string {
  if (!redirectionUrl) { return '/'; }

  // Validate the input URL
  const urlPattern = /^[a-zA-Z0-9-._~:/?&=]*$/;
  if (!urlPattern.test(redirectionUrl)) {
    DDLogs.error('Invalid redirection URL. Special characters are not allowed.', { redirectionUrl });
    return '/';
  }

  // Extract base URL and query parameters
  const [baseUrl, queryParams] = redirectionUrl.split('?');
  if (!baseUrl) { return '/'; }

  // Resolve the redirection URL using the redirection map
  const resolvedPath = redirectionMap()[baseUrl] || redirectionMap()[redirectionUrl];

  if (!resolvedPath) {
    DDLogs.info('DescopeSignup handleSuccess');
    return '/';
  }

  // Append the query parameter (if it exists)
  if (queryParams && queryParams.startsWith('plan=')) {
    return `${resolvedPath}?${queryParams}`;
  }

  return resolvedPath;
}
